import { render, staticRenderFns } from "./HeaderGameKS.vue?vue&type=template&id=4103e4f6"
import script from "./HeaderGameKS.vue?vue&type=script&lang=js"
export * from "./HeaderGameKS.vue?vue&type=script&lang=js"
import style0 from "./HeaderGameKS.vue?vue&type=style&index=0&id=4103e4f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports